import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import useParams from "../../Hooks/useParams";
import AcademicCalendarService from "../../../Services/AcademicCalendar.service";
import useService from "../../Hooks/useService";
import CourseSectionService from "../../../Services/CourseSection.service";
import HomeControllerPresentation from "../../Containers/CourseScheduler/HomeControllerPresentation";
import CourseSectionSchedulerBreakService from "../../../Services/CourseSectionSchedulerBreak.service";
import CourseSectionSchedulerLocationService from "../../../Services/CourseSectionSchedulerLocation.service";
import CourseSectionSchedulerCourseSectionService from "../../../Services/CourseSectionSchedulerCourseSection.service";
import useServiceWithEdit from "../../Hooks/useServiceWithEdit";
const CourseSchedulerIndex = (props) => {
    // ----- Terms ----
    const termId = useParams().termId;
    const getTerm = React.useMemo(() => (id) => AcademicCalendarService.getTermsById([id]).then((terms) => terms[0]), []);
    const [termState, loadTerm] = useService(getTerm);
    React.useEffect(() => {
        if (termId) {
            loadTerm(termId);
        }
    }, [loadTerm, termId]);
    // ----- Selected Course Sections ----
    const getCourseSections = React.useMemo(() => (idOfTerm) => CourseSectionSchedulerCourseSectionService.getSelectedCourseSections(idOfTerm), []);
    const [courseSections, loadCourseSections, courseSectionActions, originalCourseSections,] = useServiceWithEdit(getCourseSections);
    React.useEffect(() => {
        if (termId) {
            loadCourseSections(termId);
        }
    }, [loadCourseSections, termId]);
    // ----- Courses ----
    const getCourses = React.useMemo(() => (idOfTerm) => CourseSectionService.getSchedulerCourses(idOfTerm), []);
    const [courses, loadCourses, courseActions] = useServiceWithEdit(getCourses);
    React.useEffect(() => {
        if (termId) {
            loadCourses(termId);
        }
    }, [loadCourses, termId]);
    // ----- Course Groups ----
    // We need to keep track of which courses belong to which group.
    const [courseGroupMap, setCourseGroupMap] = React.useState({});
    // This method loads in course groups and also the courses which belong
    // to them.  It updates the courseGroupMap as well as adds the courses
    // it loads to the master list of courses.
    const getCourseGroups = React.useMemo(() => (idOfTerm) => CourseSectionService.getSchedulerCourseGroups(idOfTerm).then((groups) => {
        CourseSectionService.getCoursesInCourseGroups(groups.map((g) => g.id)).then((data) => {
            data.forEach((datum) => {
                // Add these courses to the group map
                // @ts-expect-error - TS2345 - Argument of type '(groupMap: Partial<Record<string, number[]>>) => { [x: string]: string[] | number[] | undefined; }' is not assignable to parameter of type 'SetStateAction<Partial<Record<string, number[]>>>'.
                setCourseGroupMap((groupMap) => (Object.assign(Object.assign({}, groupMap), { [datum.groupId]: datum.courses.map((c) => c.id) })));
                // Add courses to our master list.
                // @ts-expect-error - TS2345 - Argument of type '(arg1: Course | Course[]) => void' is not assignable to parameter of type '(value: SchedulerCourseSection, index: number, array: SchedulerCourseSection[]) => void'.
                datum.courses.forEach(courseActions.update);
            });
        });
        return groups;
    }), [courseActions.update]);
    const [courseGroups, loadCourseGroups] = useService(getCourseGroups);
    React.useEffect(() => {
        if (termId) {
            loadCourseGroups(termId);
        }
    }, [loadCourseGroups, termId]);
    // ----- Breaks ----
    const getBreaks = React.useMemo(() => () => CourseSectionSchedulerBreakService.getBreaks(), []);
    const [breaksState, loadBreaks, breakActions] = useServiceWithEdit(getBreaks);
    React.useEffect(() => {
        loadBreaks();
    }, [loadBreaks]);
    // ----- Selected Locations ----
    const [selectedLocationsState, loadSelectedLocations, selectedLocationActions,] = useServiceWithEdit(CourseSectionSchedulerLocationService.getLocations);
    React.useEffect(() => {
        loadSelectedLocations();
    }, [loadSelectedLocations]);
    // ----- Selected Breaks ----
    const getSelectedBreakIds = React.useMemo(() => (idOfTerm) => CourseSectionSchedulerBreakService.getSelectedBreaks(idOfTerm).then((brks) => brks.map((brk) => brk.id)), []);
    const [selectedBreakIds, loadSelectedBreakIds] = useService(getSelectedBreakIds);
    React.useEffect(() => {
        if (termId) {
            loadSelectedBreakIds(termId);
        }
    }, [loadSelectedBreakIds, termId]);
    return (_jsx(HomeControllerPresentation, { courses: courses, courseActions: courseActions, courseSections: courseSections, courseSectionActions: courseSectionActions, breaks: breaksState, breakActions: breakActions, courseGroups: courseGroups, courseGroupMap: courseGroupMap, term: termState, selectedLocations: selectedLocationsState, selectedLocationActions: selectedLocationActions, selectedCourseSectionIds: Object.assign(Object.assign({}, courseSections), { data: originalCourseSections && originalCourseSections.map((sec) => sec.id) }), selectedBreakIds: selectedBreakIds }));
};
export default CourseSchedulerIndex;
